import { fieldPhaseRank } from './field-phase-rank.js';
import { templateFieldPhase } from './template-field-phase.js';
/** Core gates and event state are not custom fields, so an unknown id ranks as at creation. */
export function templateFieldPhaseRank(fieldId, fields) {
    const field = fields.find((candidate) => candidate.id === fieldId);
    return fieldPhaseRank(templateFieldPhase(field?.config));
}
//# sourceMappingURL=template-field-phase-rank.js.map